import React, { useState } from 'react';
import {
    Toolbar,
    Typography,
    Button,
    Box,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import ModelDeleteSelectedItems from '../Models/ModelDeleteSelectedItems';

const TableBulkToolbar = ({
    selectedCount,
    onBulkDelete,
    isBulkDeleting,
    bulkDeleteDisabled = false,
    onBulkRestore,
    isBulkRestoring = false,
    bulkRestoreDisabled = false,
    isArchive = false,
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng === 'ar';

    const [confirmOpen, setConfirmOpen] = useState(false);

    if (!selectedCount) return null;

    const handleOpenConfirm = () => {
        setConfirmOpen(true);
    };

    const handleCloseConfirm = () => {
        if (isBulkDeleting) return;
        setConfirmOpen(false);
    };

    const handleConfirmDelete = async () => {
        await onBulkDelete();   // تنفيذ الحذف الفعلي
        setConfirmOpen(false);  // إغلاق المودال بعد التنفيذ
    };

    return (
        <>
            <Toolbar
                sx={{
                    px: 2.5,
                    py: 1,
                    bgcolor: isDark ? '#111827' : '#E3F2FD',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: (t) => `1px solid ${t.palette.divider}`,
                }}
            >
                <Typography
                    sx={{ flex: '1 1 50%' }}
                    color="inherit"
                    variant="subtitle2"
                    component="div"
                >
                    {isArabic
                        ? `تم اختيار ${selectedCount}`
                        : `${selectedCount} selected`}
                </Typography>

                <Box sx={{ display: 'flex', gap: 1 }}>
                    {onBulkRestore && isArchive && (
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={onBulkRestore}
                            disabled={isBulkRestoring || bulkRestoreDisabled}
                        >
                            {isBulkRestoring
                                ? isArabic
                                    ? 'جاري الاستعادة...'
                                    : 'Restoring...'
                                : isArabic
                                ? 'استعادة المحدد'
                                : 'Restore selected'}
                        </Button>
                    )}

                    {onBulkDelete && (
                        <Button
                            variant="contained"
                            color={isArchive ? "error" : "warning"}
                            size="small"
                            onClick={handleOpenConfirm}
                            disabled={isBulkDeleting || bulkDeleteDisabled}
                            title={
                                bulkDeleteDisabled
                                    ? isArabic
                                        ? 'لا تملك صلاحية حذف المحدد'
                                        : 'No bulk delete permission'
                                    : ''
                            }
                        >
                            {isBulkDeleting
                                ? isArabic
                                    ? (isArchive ? 'جاري الحذف النهائي...' : 'جاري الأرشفة...')
                                    : (isArchive ? 'Deleting permanently...' : 'Archiving...')
                                : isArabic
                                ? (isArchive ? 'حذف نهائي للمحدد' : 'أرشفة المحدد')
                                : (isArchive ? 'Delete permanently' : 'Archive selected')}
                        </Button>
                    )}
                </Box>
            </Toolbar>

            {/* مودال تأكيد الحذف الجماعي */}
            <ModelDeleteSelectedItems
                confirmOpen={confirmOpen}
                handleCloseConfirm={handleCloseConfirm}
                isArabic={isArabic}
                selectedCount={selectedCount}
                isBulkDeleting={isBulkDeleting}
                handleConfirmDelete={handleConfirmDelete}
            />
        </>
    );
};

export default TableBulkToolbar;
